import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

/**
 * Shown when the user is signed in but has not verified their email yet.
 */
const EmailVerificationBanner: React.FC = () => {
  const { user, refreshUser } = useAuth();
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  if (!user || user.email_verified_at) {
    return null;
  }

  const handleResend = async () => {
    setMsg(null);
    setSending(true);
    try {
      await authService.resendVerification();
      setMsg('Check your inbox for a new verification link.');
      await refreshUser();
    } catch {
      setMsg('Could not send email right now. Try again in a few minutes.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-surface-muted border-b border-border px-4 py-3 lg:pl-72">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 max-w-6xl mx-auto">
        <p className="text-sm text-fg">
          <span className="font-medium">Verify your email</span>
          {' — '}
          Confirm your address to unlock email and larger imports.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          {msg && <span className="text-xs text-fg-secondary">{msg}</span>}
          <button
            type="button"
            disabled={sending}
            onClick={handleResend}
            className="text-sm font-medium text-primary hover:underline disabled:opacity-50"
          >
            {sending ? 'Sending…' : 'Resend email'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
